import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player";

const VideoPlayer = () => {
  const { category, courseName, subjectName, topicName } = useParams();
  const [sources, setSources] = useState([]);

  const normalizedCategory = decodeURIComponent(category);
  const normalizedCourse = decodeURIComponent(courseName);
  const normalizedSubject = decodeURIComponent(subjectName);
  const normalizedTopic = decodeURIComponent(topicName);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/course/coursedetails`);
        const data = await response.json();
        setSources(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Step 1: filter normally (as you want)
  let filteredData = sources.filter(
    (item) =>
      item.category_name === normalizedCategory &&
      item.course_name === normalizedCourse &&
      item.subject_name === normalizedSubject &&
      item.topic_title === normalizedTopic
  );

  // Step 2: remove duplicates (show only 1 video)
  filteredData = filteredData.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.topic_url === item.topic_url)
  );

  return (
    <div style={{ width: "100%", height: "100vh", background: "#000" }}>
      {filteredData.length > 0 ? (
        <ReactPlayer
          src={filteredData[0].topic_url}
          width="100%"
          height="100%"
          controls={true}
        />
      ) : (
        <p style={{ color: "white", textAlign: "center", marginTop: "50px", fontSize: "20px" }}>
          No video found for this topic.
        </p>
      )}
    </div>
  );
};

export default VideoPlayer;
